import styled from "styled-components";

export const IconWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;
  width: ${({ $width }) => ($width ? $width : "auto")};
  height: ${({ $height }) => ($height ? $height : "auto")};
  position: relative;

  ${({ $hoverColor }) =>
    $hoverColor &&
    `
    &:hover {
      color: ${$hoverColor};
    }
  `}

  > div {
    display: flex;
    width: 100%;
    height: 100%;
    color: inherit;
    pointer-events: none;
    justify-content: center;
    align-items: stretch;
  }

  svg {
    width: 100%;
    height: 100%;
    color: inherit; // passing color through to svg
    pointer-events: none;
  }
`;
